<template>
  <div>
    <fg-input :label="label">
      <el-date-picker
        type="date"
        value-format="yyyy-MM-dd"
        format="dd.MM.yyyy"
        :value="realValue"
        @input="emitFilter"
      >
      </el-date-picker>
    </fg-input>
  </div>
</template>

<script lang="babel">
import { DatePicker } from 'element-ui';
import { FgInput } from "src/components/UIComponents";

export default {
    components: {
      [DatePicker.name]: DatePicker,
      [FgInput.name]: FgInput,
    },
    props: ['label', 'attributes', 'value', 'id'],
    data () {
      return {
        lastEmittedValue: null
      };
    },
    computed: {
      realValue() {
        if (!this.value) {
          return null;
        }

        return this.value[0].value;
      }
    },
    methods: {
      emitFilter(date) {
        // Avoid emitting null multiple times
        if (this.lastEmittedValue === date) {
          return;
        }

        this.lastEmittedValue = date;

        let filter = { name: 'whereDate', id: this.id };
        if (date) {
          filter.attributes = [
            { column: this.attributes.column, operator: this.attributes.operator, value: date }
          ]
        }
        this.$emit('filter-change', filter);
      }
    }
};
</script>
